import { COLORS } from '@/styles/tokens/colors';

export const HEADER_BACKGROUND_COLOR = COLORS.GRAY[100];
export const ROW_BORDER_STYLE = `1px solid ${COLORS.GRAY[200]} !important`;
